import * as React from 'react';
import TimelineFullImage from '../../../../timeline/TimelineFullImage/TimelineFullImage';

const Image = require('../../../../../assets/img/timeline/modal/1987-relocate.jpg');

const RelocateContent = () => {
    return (
        <>
            <TimelineFullImage image={Image} />
            <h4>
                BCT relocates to Newcastle
            </h4>
            <p>
                Breast Cancer Trials relocated to Newcastle in the Department of Surgical Oncology at the Newcastle Mater Hospital. Professor John Forbes AM was made the first inaugural Chair of Surgical Oncology at the University of Newcastle. 
            </p>
        </>
    );
}

export default RelocateContent;